import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import { Control } from "../../ui-kit/control";
import { resolveFileUrl } from "constants/config";
import { Button, PhotoDropzone } from "../../ui-kit/styled-templates";

import Select from "react-select";
import ReactQuill from "react-quill";
import axios from "axios";
import toast from "react-hot-toast";

const MODER_OPTIONS = [
    {
        label: "Модерация не пройдена",
        value: false
    },
    {
        label: "Модерация пройдена",
        value: true
    }
];

export default function UpdatePostForm(props) {
    const {
        onSave = d => {

        },
        loading = false,
        canDelete = false,
        onDelete = () => {

        },
        isAdmin = false,
        isModerated,
        author
    } = props;

    const [url, setUrl] = useState(props.url || "");
    const [moderationComment, setModerationComment] = useState(props.moderationComment || "");
    const [name, setName] = useState(props.name || "");
    const [description, setDescription] = useState(props.description || "");
    const [html, setHtml] = useState(props.html || "");
    const [avatar, setAvatar] = useState(props.avatar);


    return (
        <Wrapper>

            {author && (
                <AuthorInfoBlock>
                    <AuthorAvatar src={resolveFileUrl(author.photo || author.avatar)} />
                    <AuthorDetails>
                        <AuthorName
                            onClick={() => window.open(`/ambassadors/${author.id}`, "_blank")}
                        >
                            {author.name || `${author.firstName || ''} ${author.lastName || ''}`.trim()}
                        </AuthorName>
                        <AuthorEmail>{author.email}</AuthorEmail>
                    </AuthorDetails>
                </AuthorInfoBlock>
            )}

            {isAdmin == false ? null :
                <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <Label>
                        Модерация
                    </Label>

                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: 20
                    }}>
                        {MODER_OPTIONS.map((a, i) => {
                            return (
                                <div key={i} style={{
                                    marginRight: 20,
                                    padding: "5px",
                                    paddingLeft: "12px",
                                    paddingRight: "12px",
                                    border: "1px solid lightgrey",
                                    cursor: "pointer",
                                    borderRadius: 1000
                                }}
                                     onClick={async () => {
                                         onSave({
                                             isModerated: a.value
                                         });
                                     }}>
                                    <input type="checkbox"
                                           checked={(isModerated == undefined ? false : isModerated) == a.value}

                                    />
                                    <span style={{ marginLeft: 10 }}>
                                                                            {a.label}
                                                                        </span>
                                </div>
                            );
                        })}
                    </div>

                    {isModerated == true ? null :
                        <div>
                            <Row>
                                <Control.Textarea
                                    value={moderationComment}
                                    label={"Причина отклонения"} placeholder={""} isRequired
                                    onChange={evt => {
                                        setModerationComment(evt.target.value);
                                    }}
                                />
                            </Row>
                        </div>
                    }

                    {/*<Select*/}
                    {/*    options={MODER_OPTIONS}*/}
                    {/*    value={MODER_OPTIONS.find(x => (x.value == isModerated))}*/}
                    {/*    onChange={v => {*/}
                    {/*        let newIsModerated = v.value;*/}
                    {/*        onSave({*/}
                    {/*            isModerated: newIsModerated*/}
                    {/*        });*/}
                    {/*    }}*/}
                    {/*/>*/}

                </div>
            }

            <Row>
                <Control.File name="avatar" accept="image/jpeg, image/png" className={"avatar_placeholder"}
                              onChange={evt => {
                                  setAvatar(evt.target.value);
                              }}
                >
                    {avatar == undefined ? <PhotoDropzone
                            label={'Загрузить фотографию (формат JPG, высота 600 пикселей, ширина 900 пикселей)'}
                        /> :
                        <AvaImg src={avatar} />
                    }

                </Control.File>
            </Row>

            <Row>
                <Control.Input
                    value={name}
                    label={"Название поста"} placeholder={""} isRequired
                    onChange={evt => {
                        setName(evt.target.value);
                    }}
                />
            </Row>

            <Row>
                <Control.Input
                    value={url}
                    label={"Внешняя ссылка"} placeholder={""} isRequired
                    onChange={evt => {
                        setUrl(evt.target.value);
                    }}
                />
            </Row>

            <Row>
                <Control.Textarea
                    value={description}
                    label={"Описание поста"} placeholder={""} isRequired
                    onChange={evt => {

                        setDescription(evt.target.value);
                    }}
                />
            </Row>

            <Row>
                <ReactQuill {...props}
                            value={html}
                            onChange={(e) => {
                                setHtml(e);
                            }} />
                {/*<Control.HTML*/}
                {/*    value={html}*/}
                {/*    label={"Содержание поста"} placeholder={""} isRequired*/}
                {/*    onChange={evt => {*/}
                {/*        let newH = evt.target.value;*/}
                {/*        console.log('newH = ', newH);*/}
                {/*        setHtml(newH);*/}
                {/*    }}*/}
                {/*/>*/}
            </Row>


            <Row>
                <Button onClick={() => {
                    if (loading == true) {
                        return;
                    }
                    onSave({
                        name: name,
                        description: description,
                        html: html,
                        avatar: avatar,
                        moderationComment: moderationComment,
                        url: url
                    });
                }}>
                    {loading == true ? "..." : "Сохранить"}
                </Button>
            </Row>

            {canDelete == false ? null :
                <Row style={{ marginTop: 20 }}>
                    <DeleteSpan onClick={() => {
                        onDelete();
                    }}>
                        Удалить пост
                    </DeleteSpan>
                </Row>
            }

        </Wrapper>
    );
}

const AvaImg = styled.img`
  height: 400px;
`;

const DeleteSpan = styled.span`
  cursor: pointer;
  color: red;

  :hover {
    opacity: 0.6;
  }
`;

const Wrapper = styled.div`
  text-align: left;
`;

const Label = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const Row = styled.div`
  margin-bottom: 20px;
  text-align: left;
`;

const AuthorInfoBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 20px;
`;

const AuthorAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-image: url("${({ src }) => src}");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #ddd;
  flex-shrink: 0;
`;

const AuthorDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const AuthorName = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #02bf89;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const AuthorEmail = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: #666;
`;